import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const navItems = [
    {
        title: 'About Us',
        children: [
            { title: 'Overview', path: '/about' },
            { title: 'Our Leadership & Governance', path: '/leadership' },
            { title: 'Institutional History', path: '/vision&mission' },
        ],
    },
    {
        title: 'Academics',
        children: [
            {
                title: 'Colleges and Courses',
                children: [
                    { title: 'Apex Institute of Technology (Engineering)', path: '/Apex-Institute-of-Technology-(Engineering)' },
                    { title: 'Apex College of Management and Computer Application', path: '/Apex-College-of-Management-and-Computer-Applications' },
                    { title: 'Apex College of Education', path: '/College-of-Education' },
                    { title: 'Apex College of Pharmacy', path: '/College-of-pharmacy' },
                ],
            },
            {
                title: 'Programs & Degrees',
                children: [
                    {
                        title: 'Undergraduate',
                        children: [
                            { title: 'Engineering (B.Tech.)', path: '/engineering' },
                            { title: 'BCA', path: '/bca' },
                            { title: 'BBA', path: '/management' },
                            { title: 'B.Com(Hons)', path: '/commerce' },
                            { title: 'B. Pharmacy', path: '/pharma' },
                            { title: 'D. Pharmacy', path: '/pharma' },
                            { title: 'B.Ed.', path: '/education' },
                            { title: 'BSc Home Sc.', path: '/education' },
                        ]
                    },
                    { title: 'Postgraduate', children: [{ title: 'MBA', path: '/programs/mba' }] },
                    {
                        title: 'Certificate & Diploma',
                        children: [
                            { title: 'Polytechnic/Diploma Engineering', path: '/programs/polytechnic' },
                            { title: 'PMKVY', path: '/programs/pmkvy' },
                            { title: 'Skill India', path: '/programs/skill-india' },
                        ]
                    },
                ],
            },
            {
                title: 'Research & Innovation',
                children: [
                    { title: 'International Conference-2025', path: '/research/conference-2025' },
                    { title: 'Incubation Centre', path: '/research/incubation' },
                ]
            },
            { title: 'Academic Calendar & Policies', path: '/academics/calendar-policies' },
        ],
    },
    { title: 'Admissions', path: 'https://admission.apex.ac.in' },
    { title: 'Gallery', path: '/gallery' },
    { title: 'Mandatory Disclosure', path: '/disclosure' },
    { title: 'Grievance', path: '/grievance' },
];

const MenuItem = ({ item, depth, isMobile, openMenus, toggleMenu, closeAllMenus }) => {
    const hasChildren = item.children && item.children.length > 0;
    const isOpen = !!openMenus[item.title];
    const hoverTimerRef = useRef(null);

    const handleMouseEnter = () => {
        if (!isMobile) {
            clearTimeout(hoverTimerRef.current);
            toggleMenu(item.title, true);
        }
    };

    const handleMouseLeave = () => {
        if (!isMobile) {
            hoverTimerRef.current = setTimeout(() => {
                toggleMenu(item.title, false);
            }, 150);
        }
    };

    const handleToggleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleMenu(item.title, !isOpen);
    };

    return (
        <li
            className={`menu-item depth-${depth} ${isOpen ? 'is-open' : ''}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="link-row">
                <Link 
                    to={item.path || '#'} 
                    className="nav-link" 
                    onClick={() => !hasChildren && closeAllMenus()}
                >
                    {item.title}
                </Link>
                {hasChildren && (
                    <button className="arrow-btn" onClick={handleToggleClick}>
                        <span className={`arrow-icon ${isOpen ? 'up' : 'down'}`} />
                    </button>
                )}
            </div>

            {hasChildren && (
                <ul className="dropdown-menu">
                    {item.children.map((child, index) => (
                        <MenuItem
                            key={index}
                            item={child}
                            depth={depth + 1}
                            isMobile={isMobile}
                            openMenus={openMenus}
                            toggleMenu={toggleMenu}
                            closeAllMenus={closeAllMenus}
                        />
                    ))}
                </ul>
            )}
        </li>
    );
};

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1024);

    useEffect(() => {
        const handleResize = () => {
            const isMob = window.innerWidth <= 1024;
            setIsMobileView(isMob);
            if (!isMob) setIsMobileMenuOpen(false);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleMenu = (title, shouldOpen) => {
        setOpenDropdowns(prev => ({ ...prev, [title]: shouldOpen }));
    };

    return (
        <>
            <nav className="main-navbar">
                <div className="nav-container">
                    {/* Brand Section */}
                    <Link to="/" className="nav-brand" onClick={() => setIsMobileMenuOpen(false)}>
                        <img src="/img/apex_logo.png" alt="Logo" className="logo-img" />
                        <div className="brand-text">
                            <h1 className="title">Apex Group of Institutions</h1>
                            <p className="subtitle">
                                B.TECH | POLYTECHNIC | MBA | BBA | BCA | B.COM | B.ED | D.PHARM | B.PHARM
                            </p>
                        </div>
                    </Link>

                    {/* Hamburger */}
                    <button 
                        className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} 
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <span className="bar"></span>
                        <span className="bar"></span>
                        <span className="bar"></span>
                    </button>

                    {/* Links */}
                    <ul className={`nav-links-container ${isMobileMenuOpen ? 'show' : ''}`}>
                        {navItems.map((item, index) => (
                            <MenuItem
                                key={index}
                                item={item}
                                depth={0}
                                isMobile={isMobileView}
                                openMenus={openDropdowns}
                                toggleMenu={toggleMenu}
                                closeAllMenus={() => setIsMobileMenuOpen(false)}
                            />
                        ))}
                    </ul>
                </div>
            </nav>
            {isMobileMenuOpen && <div className="nav-overlay" onClick={() => setIsMobileMenuOpen(false)} />}
        </>
    );
};

export default Navbar;